import { Accordion } from "react-bootstrap";

export default function TreatmentFAQ({ faqs }) {
  return (
    <>
      <h3 className="fw-bold mt-5 mb-3">Frequently Asked Questions</h3>
      <Accordion>
        {faqs.map((faq, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header>{faq.q}</Accordion.Header>
            <Accordion.Body>{faq.a}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
}
